export class TCPUpdate {
    public UserWarningMessageCode: number;
}
